export function formatEuro(amount: number): string {
  return new Intl.NumberFormat('fi-FI', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatEuroCompact(amount: number): string {
  if (Math.abs(amount) >= 1000000) {
    return `€${(amount / 1000000).toFixed(1)}M`;
  } else if (Math.abs(amount) >= 1000) {
    return `€${(amount / 1000).toFixed(1)}K`;
  }
  return formatEuro(amount);
}
